import RoundedButton from 'components/RoundedButton';
import { formattedTokenCost } from 'utils/common';
import RetroIconSVG from '../RetroIconSVG';

interface IPurchaseConfirmation {
  tokensPurchased: number;
  onClose: () => void;
  currentPageName?: string;
}

export const PurchaseConfirmation = ({
  tokensPurchased,
  onClose,
  currentPageName = 'Token Town',
}: IPurchaseConfirmation) => {
  return (
    <div className="purchaseConfirmation">
      <RetroIconSVG fname="arcade-star-green" />
      <h3>Success!</h3>

      <p>
        {formattedTokenCost(tokensPurchased)} have been added to your account.
      </p>

      <RoundedButton onClick={onClose}>
        Return to {currentPageName}
      </RoundedButton>
    </div>
  );
};
